import React from 'react';
import { Link } from 'react-router-dom';
import authArtwork from '../assets/images/tarot-spread-keith.jpg';
import { useI18n } from '../i18n/I18nContext';
import '../style/Auth.css';

export const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M21.35 12.23c0-.71-.06-1.4-.18-2.07H12v3.91h5.24a4.48 4.48 0 0 1-1.94 2.94v2.54h3.14c1.84-1.69 2.91-4.19 2.91-7.32Z" />
    <path fill="#34A853" d="M12 21.75c2.62 0 4.82-.87 6.43-2.36l-3.14-2.54c-.87.58-1.98.93-3.29.93-2.53 0-4.67-1.71-5.44-4.01H3.32v2.62A9.72 9.72 0 0 0 12 21.75Z" />
    <path fill="#FBBC05" d="M6.56 13.77a5.84 5.84 0 0 1 0-3.54V7.61H3.32a9.74 9.74 0 0 0 0 8.78l3.24-2.62Z" />
    <path fill="#EA4335" d="M12 6.22c1.43 0 2.71.49 3.72 1.45l2.79-2.79A9.36 9.36 0 0 0 12 2.25a9.72 9.72 0 0 0-8.68 5.36l3.24 2.62C7.33 7.93 9.47 6.22 12 6.22Z" />
  </svg>
);

const AuthShell = ({
  eyebrow,
  title,
  description,
  storyTitle,
  storyBody,
  alternateText,
  alternateLabel,
  alternatePath,
  raisedStory = false,
  children,
}) => {
  const { t } = useI18n();
  return (
  <main className="auth-page">
    <section className={`auth-shell${raisedStory ? ' auth-shell--raised-story' : ''}`}>
      <aside className="auth-story">
        <img src={authArtwork} alt={t('auth.artworkAlt')} />
        <div className="auth-story-overlay" />
        <div className="auth-story-top">
          <span>{t('auth.private')}</span>
          <span>{t('auth.secure')}</span>
        </div>
        <div className="auth-story-copy">
          <p className="eyebrow">{t('auth.clearer')}</p>
          <h2>{storyTitle}</h2>
          <p>{storyBody}</p>
          <div className="auth-trust-row">
            <span><i>01</i> {t('auth.choose')}</span>
            <span><i>02</i> {t('auth.reserve')}</span>
            <span><i>03</i> {t('auth.meet')}</span>
          </div>
        </div>
      </aside>

      <div className="auth-panel">
        <div className="auth-panel-inner">
          <p className="auth-eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p className="auth-description">{description}</p>
          {children}
          <p className="auth-alternate">
            {alternateText}{' '}
            <Link to={alternatePath}>{alternateLabel}</Link>
          </p>
          <p className="auth-legal-note">
            {t('auth.legalBefore')} <Link to="/terms">{t('auth.terms')}</Link> {t('auth.legalMiddle')} <Link to="/privacy">{t('auth.privacy')}</Link>.
            {' '}{t('auth.googleBefore')} <Link to="/account-and-google-privacy">{t('auth.googleData')}</Link>.
          </p>
        </div>
      </div>
    </section>
  </main>
  );
};

export default AuthShell;
